var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"headerFormItem"}},[_c('div',{staticClass:"my-6 text-center"},[_c('h3',{staticClass:"instructionText"},[_vm._v(_vm._s(_vm.instruction)+" ")]),_c('p',{staticClass:"text-md"},[_vm._v(_vm._s(_vm.description)+" ")]),_c('p',{staticClass:"text-sm italic"},[_vm._v(_vm._s(_vm.required))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }